import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from "./SimplyBookModal.scss";
import blockStyles from '@baseStyles/block.scss';
import Modal from "@components/base/Modal/Modal";
import SimplyBookWidget from "@components/widgets/SimplyBookWidget/SimplyBookWidget";

// Modal that hosts the SimplyBook.me booking widget.
const SimplyBookModal = ({config, title = '', onClose = () => {}, color = ''}) => {

	const [isModalOpen, setIsModalOpen] = useState(true);

	if (!isModalOpen || !config?.company) {
		return null;
	}

	const close = () => {
		setIsModalOpen(false);
		onClose();
	};

	return (
	  <Modal onClose={close}>
		  <div className={styles.containerScroll}>
			  <div className={`${styles.container} ${color ? blockStyles[color] : ''}`}>
				  {title &&
					<h3 dangerouslySetInnerHTML={{__html: title}}/>
				  }

				  <div className={styles.widgetHolder}>
					  <SimplyBookWidget
						company={config.company}
						theme={config.theme}
						themeSettings={config.themeSettings}
						predefined={config.predefined}
						timeline={config.timeline}
						datepicker={config.datepicker}
						isRtl={config.isRtl}
						appConfig={config.appConfig}
					  />
				  </div>
			  </div>
		  </div>
	  </Modal>
	);
};

SimplyBookModal.propTypes = {
	config: PropTypes.shape({
		company: PropTypes.string,
		theme: PropTypes.string,
		themeSettings: PropTypes.object,
		predefined: PropTypes.object,
		timeline: PropTypes.string,
		datepicker: PropTypes.string,
		isRtl: PropTypes.bool,
		appConfig: PropTypes.object
	}).isRequired,
	title: PropTypes.string,
	onClose: PropTypes.func,
	color: PropTypes.string
};

export default SimplyBookModal;
